import './index.css'

const NotFound = () => (
  <div className="not-found-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png"
      alt="not found"
      className="not-found-img"
    />
    <h1 className="h6">Page Not Found</h1>
    <p>we are sorry, the page you requested could not be found.</p>
  </div>
)

export default NotFound
